// Constants for different requests for current reducer
export default {
  taskRecords: 'TASK_RECORDS',
  updateTaskRecords: 'UPDATE_TASK_RECORDS',
  createTaskRecord: 'CREATE_TASK_RECORD',
};
